'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasVisitorEmail = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _keyPaths = require('../constants/keyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasVisitorEmail = exports.hasVisitorEmail = (0, _getIn2.default)(_keyPaths.HAS_VISITOR_EMAIL);


//////////////////
// WEBPACK FOOTER
// ./js/widget-data/operators/hasVisitorEmail.js
// module id = 862
// module chunks = 2 3